export default __webpack_public_path__ + "static/media/sad.9a1ffe5a.svg";